import React from 'react'
import Layout from '../components/Layout'
import TargetForm from '../components/Forms/TargetForm'
import { ROUTES } from '../shared/constants'

export default function Target() {
  return (
    <Layout heading="Target" heading2="Add" url1={ROUTES.ALL_TARGETS} none>
      <div style={{ padding: '0px 20px' }}>
        <TargetForm />
      </div>
    </Layout>
  )
}
